import { TextField } from "@mui/material"

export const GlobalFilter = ({ filter, setFilter }) => {

    return (
        <span className="global-container">
        <TextField id='outlined-basic' label="Search" value={filter || ''} onChange={(event)=>{setFilter(event.target.value)}}></TextField>
        </span>
    )
  }